import { TrebekTriviaGame } from "@core/models/events/trebek-trivia-game.interface";
import { TriviaGame, TriviaGameRounds, TriviaRoundQuestion } from "@models";
import { v4 as uuid } from 'uuid';

export function modifyFunctionStructure(game: TrebekTriviaGame): TriviaGame {
  let oldGame = game;
  let newGame: TriviaGame = {
    trivia_game: {
      ...oldGame,
      format_graphic_url: "",
      game_theme: oldGame?.trivia_game_themes?.game_theme,
      keywords: "", // oldGame.keywords
      theme: "", // ????
      trivia_game_rounds: [],
      trivia_game_rounds_length: 0,
      state: null,
      start_datetime: null
    }
  };

  newGame.trivia_game.trivia_game_rounds = game?.trivia_game_rounds.map(round => round.trivia_round).map((round) => {
    let newRound: TriviaGameRounds = {
      trivia_round: {
        created_at: round.created_at,
        name: "",
        game_theme: round.trivia_round_themes[0].game_theme,
        round_id: round.round_id,
        trivia_round_type: round.trivia_round_type,
        trivia_round_questions: []
      },
      round_order: round.round_order,
      round_questions_count: 0
    };
    const questionsLength: number = round.trivia_round_questions.length;
    newRound.round_questions_count = questionsLength;

    newRound.trivia_round.view_type = {
      view_type_id: 0,
      view_type_name: 'Standard',
    };

    newRound.trivia_round.trivia_round_questions = round.trivia_round_questions.reduce((acc,question) => {
      let newQuestion: TriviaRoundQuestion = {
        answer_type: question.answer_type,
        question: {
          ...question.question,
          is_alcohol: null,// question.question.is_alcohol, how to convert 0|1 to bool?
          market: question.question.market,
          question_json: {
            ...question.question.question_json,
            addedFields: [], // is this used for something?
            secondImage: "",
            firstAnswer: "",
            secondAnswer: "",
            firstImage: "",
            correctAnswers: null
          },
          question_text: question.question.question_json?.question_text,
          question_type: question.question.question_type,
          rejection_note: "",
          source_primary: "",
          source_secondary: "",
          source_tertiary: ""
        },
        question_id: question.question.question_id,
        question_order: 0,
        wager: question.wager,
        updated_at: question.updated_at,
        wager_range_value: null
      };

      newQuestion.question.question_json.answer = replaceApostrophe(String(question.question.question_json.answer));

      const answersList = question?.question?.question_json?.answers
      if (answersList) {
        newQuestion.question.question_json.answers = Object.keys(answersList).reduce((acc, i) => {
          acc[replaceApostrophe(i)] = answersList[i]
          return acc
        }, {})
      }

      // Answer type isn't input.
      if (question.answer_type.answer_type_id == 1) {
        newQuestion.question.question_json.answers = {};
        question.question.question_json.answers[
          question.question.question_json.answer as string
        ] = true;

        question.question.question_json.answers[
          question.question.question_json.wrongAnswer1
        ] = false;

        question.question.question_json.answers[
          question.question.question_json.wrongAnswer2
        ] = false;

        question.question.question_json.answers[
          question.question.question_json.wrongAnswer3
        ] = false;
      } else { // answer type IS input
        const questionTypeId = question.question.question_type.question_type_id;
        if (
          (questionTypeId === 10 || questionTypeId === 9 || questionTypeId === 8 || questionTypeId === 13) &&
          questionsLength === 1
        ) {
          // Question type is Picture.
          // This kind of rounds includes just one question in trebek.

          // Adding new property to print corresponding view.
          newRound.trivia_round.view_type = getBonusType(questionTypeId);

          newRound.trivia_round.round_text = question.question?.question_text;

          if (questionTypeId === 10) {
            const mainQuestionData = JSON.stringify(question.question);

            const items = question.question.question_json.items;

            let question_order: number = 1;
            for (let item of items) {
              const newId: string = uuid();
              // Creating subquestion.
              const newQuestionData: TriviaRoundQuestion = {
                // Implementing the data of general question for subquestions.
                question: JSON.parse(mainQuestionData),
                question_id: newId,
                question_order: question_order,
                updated_at: question.updated_at,
                answer_type: {
                  answer_type_id: 2,
                  answer_type_name: 'Input',
                },
                wager: false,
                wager_range_value: null
              };

              newQuestionData.question.point_value = 2;
              newQuestionData.question.question_text = null;
              newQuestionData.question.question_id = newId;

              const newQuestionDataJson =
                newQuestionData.question.question_json;

              newQuestionDataJson.answers = { [replaceApostrophe(String(item.itemtext))]: true };
              newQuestionDataJson.question_text = null;
              newQuestionDataJson.answer = replaceApostrophe(String(item.itemtext));
              newQuestionDataJson.image = item.image;

              newQuestionData.question.question_json = newQuestionDataJson;

              acc = [...acc, newQuestionData]

              // newQuestion.question.question_json = newQuestionDataJson // will be needed after changing to recude/acc?

              question_order += 1;
            }

          } else if (questionTypeId === 9) { // choose ten question type

            newQuestion.question.point_value = 2;
            newQuestion.question.question_json = {
              ...question.question.question_json,
              answer: question.question.question_json.correctAnswers.map((item) => item.correct_answer),
              addedFields: [],
              secondImage: "",
              firstAnswer: "",
              secondAnswer: "",
              firstImage: ""
            }

          // puzzle-matching and two column
          } else if (questionTypeId === 8 || questionTypeId === 13) {

            const mainQuestionData = JSON.stringify(question.question);

            const items = question.question.question_json.items;

            let question_order: number = 1;
            for (let item of items) {
              const newId: string = uuid();
              // Creating subquestion.
              const newQuestionData: TriviaRoundQuestion = {
                // Implementing the data of general question for subquestions.
                question: JSON.parse(mainQuestionData),
                question_id: newId,
                question_order: question_order,
                updated_at: question.updated_at,
                answer_type: {
                  answer_type_id: 2,
                  answer_type_name: 'Input',
                },
                wager: false,
                wager_range_value: null,
              };

              newQuestionData.question.point_value = 2;
              newQuestionData.question.question_text = null;
              newQuestionData.question.question_id = newId;

              const newQuestionDataJson =
                newQuestionData.question.question_json;

              newQuestionDataJson.answers = {};
              newQuestionDataJson.question_text = item.firstMatch.itemtext;
              if (questionTypeId === 8) {
                newQuestionDataJson.answers[replaceApostrophe(String(item.firstMatch.itemtext))] = true;
                newQuestionDataJson.question_text = null;
              }
              newQuestionDataJson.answers[replaceApostrophe(String(item.secondMatch.itemtext))] = true;
              newQuestionDataJson.firstImage = item.firstMatch.image || '';
              newQuestionDataJson.firstAnswer = replaceApostrophe(String(item.firstMatch.itemtext));
              newQuestionDataJson.secondAnswer = replaceApostrophe(String(item.secondMatch.itemtext));
              newQuestionDataJson.secondImage = item.secondMatch.image || '';
              newQuestionDataJson.answer = replaceApostrophe(String(item.secondMatch.itemtext));

              acc = [...acc, newQuestionData]

              question_order += 1;
            }
          }

        } else {
          newQuestion.question.question_json.answers = {};
          newQuestion.question.question_json.answers[
            question.question.question_json.answer as string
          ] = true;
        }
      }

      if (!([10, 8, 13].includes(question.question.question_type.question_type_id)))
        return [...acc, newQuestion];
      else {
        return acc
      }
    }, []);

    return newRound;
  });

  newGame.trivia_game.trivia_game_rounds_length = game?.trivia_game_rounds.length;

  return newGame;
}

const viewTypes = {
  13: { view_type_name: 'Two Column', view_type_id: 4 },
  10: { view_type_name: 'Picture', view_type_id: 1 },
  9: { view_type_name: 'Choose Ten', view_type_id: 2 },
  8: { view_type_name: 'Puz-Matching', view_type_id: 3 },
};

function getBonusType(questionTypeId) {
  let viewType = { view_type_name: 'Standard', view_type_id: 0 };

  if (viewTypes[questionTypeId]) {
    viewType = viewTypes[questionTypeId];
  }

  return viewType;
}

function replaceApostrophe(str: string): string {
  return str.replace(/‘|’|`|'/g, '\'');
}
